import { render, staticRenderFns } from "./TacsConfig.vue?vue&type=template&id=1d0226c4&scoped=true&"
import script from "./TacsConfig.vue?vue&type=script&lang=js&"
export * from "./TacsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0226c4",
  null
  
)

export default component.exports